import React, { useContext, useEffect, useState } from "react";
import "./ClientesDashboard.css";
import {
  Button, Col, Row, Card, Statistic, Tag, Space, Switch,
  Modal, Form, Input, InputNumber, DatePicker, message
} from "antd";
import axios from "axios";
import * as links from "../../../../utils/links";
import { AuthContext } from "../../../../contexts/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faUsers, faChartLine, faExclamationTriangle, faCheckCircle, faClock } from "@fortawesome/free-solid-svg-icons";
import { AiOutlinePlusCircle, AiOutlineCheck, AiOutlineClose } from "react-icons/ai";
import { format } from "date-fns";
import Swal from 'sweetalert2'
import moment from "moment";

const ClientesDashboard = (props) => {
  const { setDataUser, authInfo, setNotiMessage } = useContext(AuthContext);
  const { dataUser } = authInfo;
  let navigate = useNavigate();

  const token = authInfo?.dataUser?.token;

  const [totalClientes, setTotalClientes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [listClientes, setListClientes] = useState(true);
  const [listClientesPendentes, setListClientesPendentes] = useState(false);
  const [listClientesInadimplentes, setListClientesInadimplentes] = useState(false);
  const [clienteAtivoOverride, setClienteAtivoOverride] = useState({});
  const [clienteAtivoLoading, setClienteAtivoLoading] = useState({});
  const [dashboardStats, setDashboardStats] = useState({
    totalClientes: 0,
    clientesAtivos: 0,
    clientesInadimplentes: 0,
    clientesPendentes: 0,
    clientesPorMes: [],
    clientesPorSituacao: [],
    receitaMensal: []
  });

  const [mensalidades, setMensalidades] = useState([]);
  const [cobrancasExtras, setCobrancasExtras] = useState([]);
const [carregandoExtras, setCarregandoExtras] = useState(false);
const [erroExtras, setErroExtras] = useState("");
const [detalhesExtrasAbertos, setDetalhesExtrasAbertos] = useState({});
  const [parcelasExtrasSelecionadas, setParcelasExtrasSelecionadas] = useState({});
const [operacaoExtraId, setOperacaoExtraId] = useState(null);
const [carregandoMensalidades, setCarregandoMensalidades] = useState(false);
const [confirmandoPagamentoId, setConfirmandoPagamentoId] = useState(null);
const [mostrarHistorico, setMostrarHistorico] = useState({});
const [erroMensalidades, setErroMensalidades] = useState("");

const [modalExtraAberto, setModalExtraAberto] = useState(false);
const [modalFinanceiroAberto, setModalFinanceiroAberto] = useState(false);
const [clienteFinanceiro, setClienteFinanceiro] = useState(null);
  // Atualização de CPF e telefone do cliente
const [modalCadastroAberto, setModalCadastroAberto] = useState(false);
const [clienteCadastro, setClienteCadastro] = useState(null);
const [salvandoCadastro, setSalvandoCadastro] = useState(false);
const [formCadastro] = Form.useForm();

  // Salvar atualização de CPF e telefone
const salvarAtualizacaoCadastro = async (valores) => {
  if (!clienteCadastro?.id || salvandoCadastro) return;

  setSalvandoCadastro(true);

  try {
    await axios.put(
      `${process.env.REACT_APP_SERVIDOR}/clientes/${clienteCadastro.id}/atualizar-cadastro`,
      {
        cpf: valores.cpf || "",
        telefone: valores.telefone || "",
      },
      {
        headers: {
          "x-access-token": token,
        },
      }
    );

    message.success("Cadastro atualizado com sucesso!");

    // Atualizar os dados do cliente no card
    setTotalClientes((anterior) =>
      anterior.map((cliente) =>
        cliente.id === clienteCadastro.id
          ? {
              ...cliente,
              cpf: valores.cpf || null,
              telefone: valores.telefone || null,
            }
          : cliente
      )
    );

    // Fechar a janela
    setModalCadastroAberto(false);
    setClienteCadastro(null);
    formCadastro.resetFields();

  } catch (erro) {
    console.error("Erro ao atualizar cadastro:", erro);

    message.error(
      erro.response?.data?.error ||
      "Não foi possível atualizar o cadastro."
    );
  } finally {
    setSalvandoCadastro(false);
  }
};
  useEffect(() => {
  console.log("ESTADO DO MODAL:", modalExtraAberto);
}, [modalExtraAberto]);
const [clienteExtra, setClienteExtra] = useState(null);
const [salvandoExtra, setSalvandoExtra] = useState(false);
const [formExtra] = Form.useForm();

const salvarCobrancaExtra = async (valores) => {
  if (!clienteExtra?.id || salvandoExtra) return;

  const confirmacao = await Swal.fire({
    title: "Confirmar cobrança extra?",
    html: `
      <b>Cliente:</b> ${clienteExtra.nome}<br/>
      <b>Valor:</b> R$ ${Number(valores.valorTotal).toFixed(2).replace(".", ",")}<br/>
      <b>Parcelas:</b> ${valores.quantidadeParcelas}<br/>
      <b>Primeiro mês:</b> ${valores.primeiraCompetencia.format("MM/YYYY")}
    `,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sim, cadastrar",
    cancelButtonText: "Cancelar",
  });

  if (!confirmacao.isConfirmed) return;

  setSalvandoExtra(true);

  try {
    await axios.post(
      `${process.env.REACT_APP_SERVIDOR}/admin/cobrancas-extras`,
      {
        clienteId: clienteExtra.id,
        descricao: valores.descricao,
        observacao: valores.observacao || "",
        valorTotal: Number(valores.valorTotal).toFixed(2),
        quantidadeParcelas: valores.quantidadeParcelas,
        primeiraCompetencia: valores.primeiraCompetencia.format("YYYY-MM"),
      },
      {
        headers: {
          "x-access-token": token,
        },
      }
    );

    message.success("Cobrança extra cadastrada com sucesso!");

    setModalExtraAberto(false);
    setClienteExtra(null);
    formExtra.resetFields();

    await carregarMensalidades();
  } catch (erro) {
    message.error(
      erro.response?.data?.erro || "Erro ao cadastrar cobrança extra."
    );
  } finally {
    setSalvandoExtra(false);
  }
};

  useEffect(() => {
  dataData();
  carregarMensalidades();
  carregarCobrancasExtras();

  const intervalId = setInterval(() => {
    carregarMensalidades();
    carregarCobrancasExtras();
  }, 60000);

  return () => clearInterval(intervalId);
}, []);

  const carregarMensalidades = async () => {
  if (!token) return;

  setCarregandoMensalidades(true);
  setErroMensalidades("");

  try {
    const resposta = await axios.get(
      `${process.env.REACT_APP_SERVIDOR}/admin/mensalidades`,
      {
        headers: {
          "x-access-token": token,
        },
      }
    );

    setMensalidades(
      Array.isArray(resposta.data?.mensalidades)
        ? resposta.data.mensalidades
        : []
    );
  } catch (erro) {
    console.error("Erro ao carregar mensalidades:", erro);
    setErroMensalidades(
      erro.response?.data?.erro ||
      "Não foi possível consultar as mensalidades."
    );
  } finally {
    setCarregandoMensalidades(false);
  }
};

  const carregarCobrancasExtras = async () => {
  if (!token) return;

  setCarregandoExtras(true);
  setErroExtras("");

  try {
    const resposta = await axios.get(
      `${process.env.REACT_APP_SERVIDOR}/admin/cobrancas-extras`,
      {
        headers: {
          "x-access-token": token,
        },
      }
    );

    setCobrancasExtras(
      Array.isArray(resposta.data?.cobrancas)
        ? resposta.data.cobrancas
        : []
    );
  } catch (erro) {
    console.error("Erro ao carregar cobranças extras:", erro);

    setErroExtras(
      erro.response?.data?.erro ||
      "Não foi possível consultar as cobranças extras."
    );
  } finally {
    setCarregandoExtras(false);
  }
};

  const confirmarPagamentoParcelasExtras = async (extra) => {
  if (operacaoExtraId) return;

  const selecionadas = parcelasExtrasSelecionadas[extra.id] || [];

  const parcelas = (extra.parcelas || []).filter(
    (parcela) =>
      selecionadas.includes(parcela.id) &&
      !parcela.dataPagamento
  );

  if (extra.cancelada || parcelas.length !== selecionadas.length ||
      parcelas.length === 0) {
    message.warning("Selecione parcelas pendentes válidas.");
    return;
  }

  const totalCentavos = parcelas.reduce(
    (total, parcela) => total + parcela.valorCentavos,
    0
  );

  const confirmacao = await Swal.fire({
  customClass: {
    container: "swal-financeiro",
  },
  title: "Confirmar pagamento das parcelas?",
  html:
    `<b>${parcelas.length} parcela(s)</b><br/>` +
    `<b>Total: ${formatarValorMensalidade(totalCentavos / 100)}</b><br/><br/>` +
    "Confirme somente após verificar o recebimento do PIX.",
  icon: "warning",
  showCancelButton: true,
  confirmButtonText: "Sim, recebi o pagamento",
  cancelButtonText: "Voltar",
  confirmButtonColor: "#52c41a",
});

  if (!confirmacao.isConfirmed) return;

  setOperacaoExtraId(extra.id);

  try {
    await axios.patch(
      `${process.env.REACT_APP_SERVIDOR}/admin/cobrancas-extras/${encodeURIComponent(extra.id)}/quitar`,
      { parcelasIds: selecionadas },
      {
        headers: {
          "x-access-token": token,
        },
      }
    );

    setParcelasExtrasSelecionadas((anterior) => ({
      ...anterior,
      [extra.id]: [],
    }));

    await Promise.all([
      carregarMensalidades(),
      carregarCobrancasExtras(),
    ]);

    Swal.fire({
      title: "Pagamento confirmado!",
      text: `${parcelas.length} parcela(s) registrada(s) como pagas.`,
      icon: "success",
    });
  } catch (erro) {
    Swal.fire({
      title: "Não foi possível confirmar",
      text:
        erro.response?.data?.erro ||
        "Erro ao confirmar pagamento das parcelas.",
      icon: "error",
    });
  } finally {
    setOperacaoExtraId(null);
  }
};

  const cancelarCobrancaExtra = async (extra) => {
  if (operacaoExtraId || extra.cancelada) return;

  const parcelasPendentes = (extra.parcelas || []).filter(
    (parcela) => !parcela.dataPagamento
  );

  const totalPendente = parcelasPendentes.reduce(
    (total, parcela) => total + parcela.valorCentavos,
    0
  );

  const confirmacao = await Swal.fire({
    title: "Cancelar cobrança extra?",
    html:
      `<b>${extra.descricao}</b><br/><br/>` +
      `Saldo a cancelar: <b>${formatarValorMensalidade(totalPendente / 100)}</b><br/><br/>` +
      "As parcelas já pagas permanecerão no histórico. " +
      "As parcelas pendentes deixarão de ser cobradas.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sim, cancelar cobrança",
    cancelButtonText: "Voltar",
    confirmButtonColor: "#d33",
  });

  if (!confirmacao.isConfirmed) return;

  setOperacaoExtraId(extra.id);

  try {
    await axios.patch(
      `${process.env.REACT_APP_SERVIDOR}/admin/cobrancas-extras/${encodeURIComponent(extra.id)}/cancelar`,
      {},
      {
        headers: {
          "x-access-token": token,
        },
      }
    );

    setParcelasExtrasSelecionadas((anterior) => ({
      ...anterior,
      [extra.id]: [],
    }));

    await Promise.all([
      carregarMensalidades(),
      carregarCobrancasExtras(),
    ]);

    Swal.fire({
      title: "Cobrança cancelada!",
      text: "O histórico foi preservado e o saldo pendente foi cancelado.",
      icon: "success",
    });
  } catch (erro) {
    Swal.fire({
      title: "Erro ao cancelar cobrança",
      text:
        erro.response?.data?.erro ||
        "Não foi possível cancelar a cobrança extra.",
      icon: "error",
    });
  } finally {
    setOperacaoExtraId(null);
  }
};

const confirmarPagamentoMensalidade = async (mensalidade) => {
  const confirmacao = await Swal.fire({
    title: "Confirmar pagamento?",
    html: `Você conferiu o PIX de <b>R$ ${Number(
      mensalidade.valor
    ).toFixed(2).replace(".", ",")}</b>?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Sim, confirmar pagamento",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#52c41a",
  });

  if (!confirmacao.isConfirmed) return;

  setConfirmandoPagamentoId(mensalidade.id);

  try {
    await axios.patch(
      `${process.env.REACT_APP_SERVIDOR}/admin/mensalidades/${encodeURIComponent(
        mensalidade.id
      )}/confirmar-pagamento`,
      {},
      {
        headers: {
          "x-access-token": token,
        },
      }
    );

    await carregarMensalidades();
    await carregarCobrancasExtras();

    Swal.fire({
      title: "Pagamento confirmado!",
      text: "A mensalidade foi marcada como PAGO.",
      icon: "success",
    });
  } catch (erro) {
    Swal.fire({
      title: "Erro ao confirmar pagamento",
      text:
        erro.response?.data?.erro ||
        "Não foi possível confirmar a mensalidade.",
      icon: "error",
    });
  } finally {
    setConfirmandoPagamentoId(null);
  }
};

const formatarValorMensalidade = (valor) =>
  Number(valor).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

const formatarDataMensalidade = (data) =>
  new Date(data).toLocaleDateString("pt-BR", {
    timeZone: "America/Sao_Paulo",
  });

const formatarMesMensalidade = (data) => {
  const [ano, mes] = String(data).slice(0, 10).split("-");
  return `${mes}/${ano}`;
};

  const calculateDashboardStats = (clientes) => {
    const stats = {
      totalClientes: clientes.length,
      clientesAtivos: 0,
      clientesInadimplentes: 0,
      clientesPendentes: 0,
      clientesPorMes: Array.from({length: 6}, (_, i) => {
        const date = new Date();
        date.setMonth(date.getMonth() - i);
        return {
          mes: date.toLocaleDateString('pt-BR', { month: 'short' }),
          quantidade: 0
        };
      }).reverse(),
      clientesPorSituacao: [
        { nome: 'Ativos', valor: 0, cor: '#52c41a' },
        { nome: 'Inadimplentes', valor: 0, cor: '#ff4d4f' },
        { nome: 'Pendentes', valor: 0, cor: '#faad14' }
      ]
    };

    clientes.forEach(cliente => {
      // Calcular situação do cliente
      let dataVencimentoVal = 0;
      if (cliente.dataVencimento) {
        const dt = new Date(cliente.dataVencimento);
        const dtDateOnly = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
        dataVencimentoVal = dtDateOnly.getTime();
      }

      const diferencaEmMilissegundos = new Date().getTime() - dataVencimentoVal;
      const diferencaEmDias = Math.floor(diferencaEmMilissegundos / (1000 * 60 * 60 * 24));

      if (diferencaEmDias > 10) {
        stats.clientesInadimplentes++;
        stats.clientesPorSituacao[1].valor++;
      } else if (cliente.ativo) {
        stats.clientesAtivos++;
        stats.clientesPorSituacao[0].valor++;
      } else {
        stats.clientesPendentes++;
        stats.clientesPorSituacao[2].valor++;
      }

      // Contar clientes por mês (últimos 6 meses)
      const dataInclusao = new Date(cliente.dataInclusao);
      const mesInclusao = dataInclusao.toLocaleDateString('pt-BR', { month: 'short' });
      const mesExistente = stats.clientesPorMes.find(mes => mes.mes === mesInclusao);
      if (mesExistente) {
        mesExistente.quantidade++;
      }
    });

    return stats;
  };

  const dataData = () => {
    setIsLoading(true);
    axios.get(`${process.env.REACT_APP_SERVIDOR}/clientes`, {
      headers: {
        "x-access-token": token,
        "content-type": "application/json",
      },
    }).then((res) => {
      if (res.status === 200) {
        setIsLoading(false);
        setTotalClientes(res.data);
        setListClientes(true)
        setListClientesPendentes(false)
        setListClientesInadimplentes(false)
        // Calcular estatísticas do dashboard
        const stats = calculateDashboardStats(res.data);
        setDashboardStats(stats);
      } else {
        throw new Error();
      }
    }).catch((err) => {
      setIsLoading(false);
      if ([401, 403].includes(err.response.status)) {
        // setNotiMessage('A sua sessão expirou, para continuar faça login novamente.');
        setNotiMessage({
          type: "error",
          message:
            "A sua sessão expirou, para continuar faça login novamente.",
        });
        if (dataUser.key === 'ADMIN') {
          navigate(links.ADMIN_SIGNIN)
          setDataUser(null);
        } else {
          navigate(links.SIGNIN)
          setDataUser(null);
        }
      }
    });
  };

  const dataDataPendentes = () => {
    setIsLoading(true);
    axios.get(`${process.env.REACT_APP_SERVIDOR}/clientes-analise`, {
      headers: {
        "x-access-token": token,
        "content-type": "application/json",
      },
    }).then((res) => {
      if (res.status === 200) {
        setIsLoading(false);
        setTotalClientes(res.data);
        setListClientes(false)
        setListClientesPendentes(true)
        setListClientesInadimplentes(false)
      } else {
        throw new Error();
      }
    }).catch((err) => {
      setIsLoading(false);
      if ([401, 403].includes(err.response.status)) {
        // setNotiMessage('A sua sessão expirou, para continuar faça login novamente.');
        setNotiMessage({
          type: "error",
          message:
            "A sua sessão expirou, para continuar faça login novamente.",
        });
        if (dataUser.key === 'ADMIN') {
          navigate(links.ADMIN_SIGNIN)
          setDataUser(null);
        } else {
          navigate(links.SIGNIN)
          setDataUser(null);
        }
      }
    });
  };

  const dataDataInadimplentes = () => {
    setIsLoading(true);
    axios.get(`${process.env.REACT_APP_SERVIDOR}/clientes`, {
      headers: {
        "x-access-token": token,
        "content-type": "application/json",
      },
    }).then((res) => {
      if (res.status === 200) {
        setIsLoading(false);
        const allClientes = res.data;
        const inadimplentes = allClientes.filter(cliente => {
          let dataVencimentoVal = 0;
          if (cliente.dataVencimento) {
            const dt = new Date(cliente.dataVencimento);
            const dtDateOnly = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
            dataVencimentoVal = dtDateOnly.getTime();
          }
          const diferencaEmMilissegundos = new Date().getTime() - dataVencimentoVal;
          const diferencaEmDias = Math.floor(diferencaEmMilissegundos / (1000 * 60 * 60 * 24));
          return diferencaEmDias > 10;
        });
        setTotalClientes(inadimplentes);
        setListClientes(false);
        setListClientesPendentes(false);
        setListClientesInadimplentes(true);
      } else {
        throw new Error();
      }
    }).catch((err) => {
      setIsLoading(false);
      if (err.response && [401, 403].includes(err.response.status)) {
        setNotiMessage({
          type: "error",
          message: "A sua sessão expirou, para continuar faça login novamente.",
        });
        if (dataUser.key === 'ADMIN') {
          navigate(links.ADMIN_SIGNIN)
          setDataUser(null);
        } else {
          navigate(links.SIGNIN)
          setDataUser(null);
        }
      }
    });
  };

  const getNextVencimentoDia15 = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();

    if (day > 15) {
      return moment([year, month, 15]).add(1, "month").format("YYYY-MM-DD");
    }
    return moment([year, month, 15]).format("YYYY-MM-DD");
  };

  function ativaCliente(row) {
    Swal.fire({
      title: 'Aviso',
      text: "Deseja ativar o cliente " + row.nome + " ?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim Ativar!',
      cancelButtonText: 'Não'
    }).then(async (result) => {
      if (result.value) {
        const date = getNextVencimentoDia15();
        setIsLoading(true)
        axios.post(
          `${process.env.REACT_APP_SERVIDOR}/ativar-cliente/`, { clienteId: row.id, dataVencimento: date }, {
            headers: {
              "x-access-token": token,
              "content-type": "application/json",
            },
          }
        ).then((res) => {
          setIsLoading(false)
          setNotiMessage({
            type: "success",
            message: "Cliente ativado com sucesso!",
          });
          dataData()
          setListClientes(true)
          setListClientesPendentes(false)
        }).catch((err) => {
          setIsLoading(false);
          setNotiMessage({
            type: "error",
            message: err.response?.data?.error
              ? err.response?.data?.error
              : `A sua sessão expirou, para continuar faça login novamente.`,
          });
        });
      }
    });
  }

  const alterarStatusCliente = (row, novoAtivo) => {
    const ativoAnterior = clienteAtivoOverride[row.id] ?? !!row.ativo;
    setClienteAtivoOverride((prev) => ({ ...prev, [row.id]: novoAtivo }));
    Swal.fire({
      title: "Aviso",
      text: novoAtivo
        ? `Deseja desbloquear o cliente ${row.nome}?`
        : `Deseja bloquear o cliente ${row.nome}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (!result.isConfirmed) {
        setClienteAtivoOverride((prev) => ({ ...prev, [row.id]: ativoAnterior }));
        return;
      }
      setClienteAtivoLoading((prev) => ({ ...prev, [row.id]: true }));
      axios
        .put(
          `${process.env.REACT_APP_SERVIDOR}/alterar-cliente-adm-new/${row.id}`,
          {
            nome: row.nome,
            dataVencimento: new Date(row.dataVencimento || Date.now()),
            ativo: novoAtivo,
          },
          {
            headers: {
              "x-access-token": token,
              "content-type": "application/json",
            },
          }
        )
        .then(() => {
          setClienteAtivoLoading((prev) => ({ ...prev, [row.id]: false }));
          setNotiMessage({
            type: "success",
            message: novoAtivo
              ? "Cliente desbloqueado com sucesso!"
              : "Cliente bloqueado com sucesso!",
          });
          setTotalClientes((prev) => {
            const next = prev.map((c) => (c.id === row.id ? { ...c, ativo: novoAtivo } : c));
            setDashboardStats(calculateDashboardStats(next));
            return next;
          });
          setClienteAtivoOverride((prev) => {
            const next = { ...prev };
            delete next[row.id];
            return next;
          });
        })
        .catch((err) => {
          setClienteAtivoLoading((prev) => ({ ...prev, [row.id]: false }));
          setClienteAtivoOverride((prev) => ({ ...prev, [row.id]: ativoAnterior }));
          setNotiMessage({
            type: "error",
            message: err.response?.data?.error ?? "Um erro ocorreu",
          });
        });
    });
  };

  const handleClienteClick = ({
    id,
    nome,
    email,
    ativo,
    dataInclusao,
    dataVencimento,
    ultimoAcesso,
    mercadoPagoToken,
    pagbankToken,
    pagbankEmail
  }) => {
    const cliente = {
      id,
      nome,
      email,
      ativo,
      dataInclusao,
      dataVencimento,
      ultimoAcesso,
      mercadoPagoToken,
      pagbankToken,
      pagbankEmail
    };
    navigate(`${links.CLIENTES_MAQUINAS}/${id}`, {
      state: cliente,
    });
  };

  return (
    <div style={{ padding: '24px' }}>
      {isLoading && <LoadingAction />}
      
      {/* Header */}
      <div style={{ marginBottom: '24px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h1 style={{ margin: 0, color: 'rgba(233, 242, 255, 0.92)', fontSize: '28px', fontWeight: '600' }}>
            <FontAwesomeIcon icon={faChartLine} style={{ marginRight: '12px' }} />
            Dashboard de Clientes
          </h1>
          <div>
            <Button type="primary" style={{ marginRight: '8px' }} onClick={() => {
  dataData();
  carregarMensalidades();
}}>
              <FontAwesomeIcon icon={faArrowsRotate} style={{ marginRight: '5px' }} />
              Atualizar
            </Button>
            <Link to={links.ADD_CLIENTES}>
              <Button type="primary" style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}>
                <AiOutlinePlusCircle />
                <span>Novo Cliente</span>
              </Button>
            </Link>
          </div>
        </div>
        
        <div className="Cliente_WarningMsgSpan">
          <span>{dataUser.warningMsg}</span>
        </div>
      </div>

      {/* Cards de Estatísticas */}
      <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
        <Col xs={24} sm={12} lg={6}>
          <Card style={{ background: 'rgba(255, 255, 255, 0.06)', border: '1px solid rgba(255, 255, 255, 0.12)' }}>
            <Statistic
              title={<span style={{ color: 'rgba(233, 242, 255, 0.72)' }}>Total de Clientes</span>}
              value={dashboardStats.totalClientes}
              prefix={<FontAwesomeIcon icon={faUsers} style={{ marginRight: '8px', color: '#1890ff' }} />}
              valueStyle={{ color: '#1890ff', fontSize: '24px' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card style={{ background: 'rgba(255, 255, 255, 0.06)', border: '1px solid rgba(255, 255, 255, 0.12)' }}>
            <Statistic
              title={<span style={{ color: 'rgba(233, 242, 255, 0.72)' }}>Clientes Ativos</span>}
              value={dashboardStats.clientesAtivos}
              prefix={<FontAwesomeIcon icon={faCheckCircle} style={{ marginRight: '8px', color: '#52c41a' }} />}
              valueStyle={{ color: '#52c41a', fontSize: '24px' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card style={{ background: 'rgba(255, 255, 255, 0.06)', border: '1px solid rgba(255, 255, 255, 0.12)' }}>
            <Statistic
              title={<span style={{ color: 'rgba(233, 242, 255, 0.72)' }}>Inadimplentes</span>}
              value={dashboardStats.clientesInadimplentes}
              prefix={<FontAwesomeIcon icon={faExclamationTriangle} style={{ marginRight: '8px', color: '#ff4d4f' }} />}
              valueStyle={{ color: '#ff4d4f', fontSize: '24px' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card style={{ background: 'rgba(255, 255, 255, 0.06)', border: '1px solid rgba(255, 255, 255, 0.12)' }}>
            <Statistic
              title={<span style={{ color: 'rgba(233, 242, 255, 0.72)' }}>Novo Cliente</span>}
              value={dashboardStats.clientesPendentes}
              prefix={<FontAwesomeIcon icon={faClock} style={{ marginRight: '8px', color: '#faad14' }} />}
              valueStyle={{ color: '#faad14', fontSize: '24px' }}
            />
          </Card>
        </Col>
      </Row>

      {/* Lista de Clientes */}
      <Card 
        title="Lista de Clientes" 
        style={{ background: 'rgba(255, 255, 255, 0.02)', border: '1px solid rgba(255, 255, 255, 0.08)' }}
        extra={
          <Space>
            <Button
              type="default"
              onClick={() => dataDataInadimplentes()}
              style={{ 
                marginLeft: '8px', 
                display: 'flex', 
                alignItems: 'center', 
                gap: '5px',
                borderColor: '#ff4d4f',
                color: '#ff4d4f'
              }}
            >
              <FontAwesomeIcon icon={faExclamationTriangle} />
              <span>Ver Inadimplentes</span>
            </Button>
            <Button
              type="default"
              onClick={() => dataDataPendentes()}
              style={{ 
                marginLeft: '8px', 
                display: 'flex', 
                alignItems: 'center', 
                gap: '5px',
                backgroundColor: '#faad14', 
                color: 'white', 
                borderColor: '#faad14' 
              }}
            >
              <AiOutlinePlusCircle />
              <span>Novo Cliente</span>
            </Button>
          </Space>
        }
      >
        <Row gutter={[16, 16]}>
          {totalClientes.map((post) => {
            const ativoAtual = clienteAtivoOverride[post.id] ?? !!post.ativo;
            let dataVencimentoVal = 0;
            const dt = new Date(post.dataVencimento);
            const dtDateOnly = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
            if (post.dataVencimento) {
              let dataVencimentoDate = new Date(post.dataVencimento);
              dataVencimentoVal = dataVencimentoDate.getTime() ?? 0;
            }

            const diferencaEmMilissegundos = new Date().getTime() - dataVencimentoVal;
            const diferencaEmDias = Math.floor(diferencaEmMilissegundos / (1000 * 60 * 60 * 24));

            const statusText = diferencaEmDias > 10 ? 'INADIMPLENTE' : 'REGULAR';
            const statusTagColor = diferencaEmDias > 10 ? '#ff4d4f' : '#52c41a';

            return (
              <Col xs={24} sm={12} lg={8} key={post.id}>
                <Card 
                  hoverable
                  style={{ 
                    cursor: 'pointer',
                    background: 'rgba(255, 255, 255, 0.06)',
                    border: '1px solid rgba(255, 255, 255, 0.12)',
                    borderLeft: `4px solid ${diferencaEmDias > 10 ? '#ff4d4f' : '#52c41a'}`
                  }}
                  onClick={() => handleClienteClick({
                    id: post.id,
                    nome: post.nome,
                    email: post.email,
                    ativo: post.ativo,
                    dataInclusao: post.dataInclusao,
                    dataVencimento: post.dataVencimento,
                    ultimoAcesso: post.ultimoAcesso,
                    mercadoPagoToken: post?.mercadoPagoToken,
                    pagbankToken: post?.pagbankToken ?? '',
                    pagbankEmail: post?.pagbankEmail ?? '',
                  })}
                >
                  <div style={{ marginBottom: '12px' }}>
  <h3
    style={{
      margin: '0 0 8px 0',
      color: 'rgba(233, 242, 255, 0.92)'
    }}
  >
    {post.nome}
  </h3>

  <p style={{ margin: '0 0 4px 0', color: 'rgba(233, 242, 255, 0.72)' }}>
    <strong>CPF:</strong>{' '}
    {post.cpf
      ? String(post.cpf).replace(/\D/g, '').replace(
          /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
          '$1.$2.$3-$4'
        )
      : 'Não informado'}
  </p>

  <p style={{ margin: '0 0 4px 0', color: 'rgba(233, 242, 255, 0.72)' }}>
    <strong>Telefone:</strong>{' '}
    {post.telefone
      ? String(post.telefone)
          .replace(/\D/g, '')
          .replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3')
          .replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3')
      : 'Não informado'}
  </p>

  <p style={{ margin: '0 0 8px 0', color: 'rgba(233, 242, 255, 0.72)' }}>
    <strong>E-mail:</strong> {post.email}
  </p>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px" }}>
                      <Tag color={statusTagColor}>{statusText}</Tag>
                      <div
                        style={{ display: "flex", alignItems: "center", gap: "8px" }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <span style={{ color: "rgba(233, 242, 255, 0.72)", fontSize: 12 }}>
                          {ativoAtual ? "Ativo" : "Bloqueado"}
                        </span>
                        <Switch
                          size="small"
                          checked={ativoAtual}
                          loading={!!clienteAtivoLoading[post.id]}
                          onChange={(checked) => alterarStatusCliente(post, checked)}
                        />
                      </div>
                    </div>
                  </div>
                
<div style={{ fontSize: '14px', color: 'rgba(233, 242, 255, 0.72)' }}>

  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 8, marginBottom: 12 }}>

    <Button
      type="primary"
      size="small"
      style={{
        backgroundColor: "#0066FF",
        borderColor: "#0066FF",
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setClienteFinanceiro(post);
        setModalFinanceiroAberto(true);
      }}
    >
      💰 Ver Financeiro
    </Button>

    <Button
      type="primary"
      size="small"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        setClienteExtra(post);
        formExtra.resetFields();
        setModalExtraAberto(true);

        console.log("Abrindo cobrança extra:", post.nome);
      }}
    >
      + Cobrança Extra
    </Button>
        <Button
  type="primary"
  size="small"
  style={{
    backgroundColor: "#1890ff",
    borderColor: "#1890ff",
  }}
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();

    setClienteCadastro(post);

    formCadastro.setFieldsValue({
      cpf: post.cpf || "",
      telefone: post.telefone || "",
    });

    setModalCadastroAberto(true);
  }}
>
  ✏️ Atualizar Cadastro
</Button>

  </div>

  <div>Total de máquinas: {post.Maquina?.length || 0}</div>

<div style={{ color: "#4ade80" }}>
  🟢 Máquinas ativas: {
    post.Maquina?.filter(
      maquina => maquina.bloqueadaMensalidade === false
    ).length || 0
  }
</div>

<div style={{ color: "#f87171" }}>
  🔴 Máquinas bloqueadas: {
    post.Maquina?.filter(
      maquina => maquina.bloqueadaMensalidade === true
    ).length || 0
  }
</div>

  <div>Vencimento: {format(dtDateOnly, 'dd/MM/yyyy')}</div>

  <div style={{ marginTop: '8px', fontSize: '12px' }}>
    Último acesso: {post.ultimoAcesso
      ? format(new Date(post.ultimoAcesso), "dd/MM/yyyy HH:mm")
      : "Nunca"}
  </div>

</div>



                        {/* =========================================
    IKPAY - MENSALIDADES AUTOMÁTICAS
========================================= */}
{false && (
  <>
<div
  onClick={(e) => e.stopPropagation()}
  style={{
    marginTop: 16,
    paddingTop: 14,
    borderTop: "1px solid rgba(255,255,255,0.15)",
    cursor: "default",
  }}
>
  <h4
    style={{
      color: "#e9f2ff",
      fontSize: 15,
      marginBottom: 12,
    }}
  >
    Mensalidades IKPAY
  </h4>

  {(() => {
    const cobrancasCliente = mensalidades
      .filter((item) => item.clienteId === post.id)
      .sort(
        (a, b) =>
          new Date(b.dataDeVencimento) -
          new Date(a.dataDeVencimento)
      );

    const cobrancaAtual = cobrancasCliente[0];
    const historicoAberto = !!mostrarHistorico[post.id];

    if (carregandoMensalidades && !mensalidades.length) {
      return <p style={{ color: "#cbd5e1" }}>Carregando mensalidades...</p>;
    }

    if (erroMensalidades) {
      return <p style={{ color: "#ff7875" }}>{erroMensalidades}</p>;
    }

    if (!cobrancaAtual) {
      return (
        <p style={{ color: "#cbd5e1", marginBottom: 0 }}>
          Nenhuma mensalidade gerada.
        </p>
      );
    }

    const statusCor = {
      ABERTO: "gold",
      VENCIDO: "red",
      PAGO: "green",
      SUBSTITUIDO: "default",
    };

    return (
      <>
        <div style={{ marginBottom: 8, color: "#e9f2ff" }}>
          <strong>
            Referência: {formatarMesMensalidade(cobrancaAtual.dataDeVencimento)}
          </strong>
        </div>

        <div
          style={{
            color: "#ffffff",
            fontSize: 22,
            fontWeight: 700,
            marginBottom: 8,
          }}
        >
          {formatarValorMensalidade(cobrancaAtual.valor)}
        </div>

        <Tag
  color={cobrancaAtual.status === "PAGO" ? "#00C853" : statusCor[cobrancaAtual.status] || "default"}
  style={{
    color: "#FFFFFF",
    fontWeight: 700,
    border: "none",
    padding: "3px 10px",
    borderRadius: "6px",
    fontSize: "12px",
  }}
>
  {cobrancaAtual.status}
</Tag>

        <div style={{ color: "#cbd5e1", fontSize: 12, marginTop: 8 }}>
          Vencimento:{" "}
          {formatarDataMensalidade(cobrancaAtual.dataDeVencimento)}
        </div>

        {cobrancaAtual.status === "PAGO" &&
          cobrancaAtual.dataDoPagamento && (
            <div style={{ color: "#73d13d", fontSize: 12, marginTop: 6 }}>
              Pago em:{" "}
              {formatarDataMensalidade(cobrancaAtual.dataDoPagamento)}
            </div>
          )}

        {["ABERTO", "VENCIDO"].includes(cobrancaAtual.status) && (
          <Button
            type="primary"
            block
            loading={confirmandoPagamentoId === cobrancaAtual.id}
            disabled={!!confirmandoPagamentoId}
            onClick={() => confirmarPagamentoMensalidade(cobrancaAtual)}
            style={{
              marginTop: 12,
              backgroundColor: "#52c41a",
              borderColor: "#52c41a",
            }}
          >
            Confirmar pagamento
          </Button>
        )}

        {cobrancasCliente.length > 1 && (
          <>
            <Button
              type="link"
              onClick={() =>
                setMostrarHistorico((anterior) => ({
                  ...anterior,
                  [post.id]: !anterior[post.id],
                }))
              }
              style={{ paddingLeft: 0, marginTop: 8 }}
            >
              {historicoAberto ? "Ocultar histórico" : "Ver histórico"}
            </Button>

            {historicoAberto &&
              cobrancasCliente.slice(1).map((cobranca) => (
                <div
                  key={cobranca.id}
                  style={{
                    borderTop: "1px solid rgba(255,255,255,0.12)",
                    padding: "10px 0",
                    color: "#cbd5e1",
                    fontSize: 12,
                  }}
                >
                  <div>
                    {formatarMesMensalidade(cobranca.dataDeVencimento)}
                    {" — "}
                    {formatarValorMensalidade(cobranca.valor)}
                  </div>

                  <Tag color={statusCor[cobranca.status] || "default"}>
                    {cobranca.status}
                  </Tag>

                  {["ABERTO", "VENCIDO"].includes(cobranca.status) && (
                    <Button
                      size="small"
                      type="primary"
                      loading={confirmandoPagamentoId === cobranca.id}
                      disabled={!!confirmandoPagamentoId}
                      onClick={() => confirmarPagamentoMensalidade(cobranca)}
                      style={{
                        marginTop: 6,
                        backgroundColor: "#52c41a",
                      }}
                    >
                      Confirmar pagamento
                    </Button>
                  )}
                </div>
              ))}
          </>
        )}
      </>
    );
  })()}
</div>

    {/* =========================================
    IKPAY - COBRANÇAS EXTRAS
========================================= */}
<div
  onClick={(e) => e.stopPropagation()}
  style={{
    marginTop: 16,
    paddingTop: 14,
    borderTop: "1px solid rgba(255,255,255,0.15)",
    cursor: "default",
  }}
>
  <h4 style={{ color: "#e9f2ff", fontSize: 15, marginBottom: 12 }}>
    Cobranças Extras
  </h4>

  {carregandoExtras && (
    <p style={{ color: "#cbd5e1" }}>Carregando cobranças...</p>
  )}

  {erroExtras && (
    <p style={{ color: "#ff7875" }}>{erroExtras}</p>
  )}

  {!carregandoExtras && !erroExtras && (() => {
    const extrasCliente = cobrancasExtras.filter(
      (extra) => extra.clienteId === post.id
    );

    if (extrasCliente.length === 0) {
      return (
        <p style={{ color: "#cbd5e1", marginBottom: 0 }}>
          Nenhuma cobrança extra cadastrada.
        </p>
      );
    }

    return extrasCliente.map((extra) => {
      const parcelas = extra.parcelas || [];

      const pagas = parcelas.filter(
        (parcela) => !!parcela.dataPagamento
      );

      const saldoCentavos = parcelas
        .filter((parcela) => !parcela.dataPagamento)
        .reduce(
          (total, parcela) => total + parcela.valorCentavos,
          0
        );

      const detalhesAbertos = !!detalhesExtrasAbertos[extra.id];

      return (
        <div
          key={extra.id}
          style={{
            padding: 12,
            marginBottom: 12,
            borderRadius: 8,
            background: "rgba(255,255,255,0.06)",
            color: "#e9f2ff",
          }}
        >
          <strong>{extra.descricao}</strong>

          <div style={{ marginTop: 8 }}>
            Valor total:{" "}
            {formatarValorMensalidade(
              extra.valorTotalCentavos / 100
            )}
          </div>

          <div>
            Parcelas pagas: {pagas.length} de {parcelas.length}
          </div>

         <div>
  {extra.cancelada ? "Saldo cancelado" : "Saldo pendente"}:{" "}
  {formatarValorMensalidade(
    extra.cancelada ? 0 : saldoCentavos / 100
  )}
</div>

          <Tag
  color={
    extra.cancelada
      ? "#FF4D4F"
      : saldoCentavos === 0
      ? "#00C853"
      : "#AD6800"
  }
  style={{
    color: "#FFFFFF",
    fontWeight: 700,
    border: "none",
    padding: "3px 10px",
    borderRadius: "6px",
    fontSize: "12px",
  }}
>
  {extra.cancelada
    ? "CANCELADA"
    : saldoCentavos === 0
    ? "QUITADA"
    : "EM ANDAMENTO"}
</Tag>

          <Button
            type="link"
            style={{ paddingLeft: 0, display: "block", marginTop: 6 }}
            onClick={() =>
              setDetalhesExtrasAbertos((anterior) => ({
                ...anterior,
                [extra.id]: !anterior[extra.id],
              }))
            }
          >
            {detalhesAbertos ? "Ocultar detalhes" : "Ver detalhes"}
          </Button>

{!extra.cancelada && saldoCentavos > 0 && (
  <Button
    type="primary"
    block
    loading={operacaoExtraId === extra.id}
    disabled={
      !!operacaoExtraId ||
      !(parcelasExtrasSelecionadas[extra.id] || []).length
    }
    onClick={() => confirmarPagamentoParcelasExtras(extra)}
    style={{
      marginTop: 10,
      backgroundColor: "#52c41a",
      borderColor: "#52c41a",
    }}
  >
    Confirmar parcelas selecionadas
  </Button>
)}

{!extra.cancelada && saldoCentavos > 0 && (
  <Button
    danger
    block
    loading={operacaoExtraId === extra.id}
    disabled={!!operacaoExtraId}
    onClick={() => cancelarCobrancaExtra(extra)}
    style={{ marginTop: 8 }}
  >
    Cancelar cobrança extra
  </Button>
)}

          {detalhesAbertos && (
            <div
              style={{
                borderTop: "1px solid rgba(255,255,255,0.15)",
                paddingTop: 10,
                fontSize: 12,
              }}
            >
              {extra.observacao && (
                <p>Observação: {extra.observacao}</p>
              )}

              {parcelas.map((parcela) => {
  const jaPaga = !!parcela.dataPagamento;
  const cancelada = !!extra.cancelada;

  const selecionadas =
    parcelasExtrasSelecionadas[extra.id] || [];

  const selecionada = selecionadas.includes(parcela.id);

  return (
    <div
      key={parcela.id}
      style={{
        marginBottom: 10,
        padding: 8,
        borderRadius: 6,
        background: "rgba(255,255,255,0.05)",
        display: "flex",
        alignItems: "center",
        gap: 10,
      }}
    >
      <input
        type="checkbox"
        checked={selecionada && !jaPaga && !cancelada}
        disabled={jaPaga || cancelada || !!operacaoExtraId}
        onChange={(e) => {
          const marcada = e.target.checked;

          setParcelasExtrasSelecionadas((anterior) => {
            const atuais = anterior[extra.id] || [];

            return {
              ...anterior,
              [extra.id]: marcada
                ? [...atuais, parcela.id]
                : atuais.filter((id) => id !== parcela.id),
            };
          });
        }}
      />

      <span>
        Parcela {parcela.numeroParcela} —{" "}
        {parcela.competencia} —{" "}
        {formatarValorMensalidade(parcela.valorCentavos / 100)}
      </span>

      <Tag
  color={jaPaga ? "#00C853" : cancelada ? "#FF4D4F" : "#AD6800"}
  style={{
    color: "#FFFFFF",
    fontWeight: 700,
    border: "none",
    padding: "3px 10px",
    borderRadius: "6px",
    fontSize: "12px",
  }}
>
  {jaPaga ? "PAGA" : cancelada ? "CANCELADA" : "PENDENTE"}
</Tag>
    </div>
  );
})}
            </div>
          )}
        </div>
      );
        });
  })()}
</div>

  </>
)}

</Card>
</Col>
            );
          })}
        </Row>

        
    
      </Card>


 <Modal
  title={`Nova cobrança extra - ${clienteExtra?.nome || ""}`}
  visible={modalExtraAberto}
  zIndex={99999}
  getContainer={document.body}
  centered
  width={600}
  wrapClassName="modal-cobranca-extra"
  bodyStyle={{
    backgroundColor: "#172238",
    padding: "20px",
  }}
  onCancel={() => {
    if (salvandoExtra) return;
    setModalExtraAberto(false);
    setClienteExtra(null);
    formExtra.resetFields();
  }}
  footer={null}
  destroyOnClose
>
  <Form
    form={formExtra}
    layout="vertical"
    onFinish={salvarCobrancaExtra}
    initialValues={{ quantidadeParcelas: 1 }}
  >
    <Form.Item
      name="descricao"
      label="Descrição"
      rules={[{ required: true, message: "Informe a descrição" }]}
    >
      <Input maxLength={300} placeholder="Ex.: Venda de aparelho" />
    </Form.Item>

    <Form.Item name="observacao" label="Observação interna">
      <Input.TextArea
        rows={3}
        maxLength={2000}
        placeholder="Detalhes da cobrança"
      />
    </Form.Item>

    <Form.Item
      name="valorTotal"
      label="Valor total (R$)"
      rules={[{ required: true, message: "Informe o valor" }]}
    >
      <InputNumber
        min={0.01}
        precision={2}
        step={0.01}
        style={{ width: "100%" }}
      />
    </Form.Item>

    <Form.Item
      name="quantidadeParcelas"
      label="Quantidade de parcelas"
      rules={[{ required: true, message: "Informe as parcelas" }]}
    >
      <InputNumber
        min={1}
        max={60}
        precision={0}
        style={{ width: "100%" }}
      />
    </Form.Item>

    <Form.Item
      name="primeiraCompetencia"
      label="Mês da primeira cobrança"
      rules={[{ required: true, message: "Selecione o mês" }]}
    >
      <DatePicker
  picker="month"
  format="MM/YYYY"
  getPopupContainer={(trigger) => trigger.parentElement}
  onChange={() => document.activeElement?.blur()}
  style={{ width: "100%" }}
/>
    </Form.Item>

    <Button
      type="primary"
      htmlType="submit"
      loading={salvandoExtra}
      block
    >
      Salvar cobrança extra
    </Button>
  </Form>
</Modal>

{/* =========================================
    IKPAY - FINANCEIRO DO CLIENTE
========================================= */}
<Modal
  title={`💰 Financeiro - ${clienteFinanceiro?.nome || ""}`}
  visible={modalFinanceiroAberto}
  onCancel={() => {
    setModalFinanceiroAberto(false);
    setClienteFinanceiro(null);
  }}
  footer={null}
  centered
  width={800}
  zIndex={99999}
  bodyStyle={{
    backgroundColor: "#172238",
    color: "#FFFFFF",
    padding: "24px",
    maxHeight: "75vh",
    overflowY: "auto",
  }}
>
  <div style={{ color: "#FFFFFF" }}>
    <h3 style={{ color: "#FFFFFF" }}>
      {clienteFinanceiro?.nome}
    </h3>

    <p style={{ color: "#CBD5E1" }}>
      {clienteFinanceiro?.email}
    </p>

    <div
      style={{
        marginTop: 20,
        padding: 20,
        backgroundColor: "#243450",
        borderRadius: 10,
      }}
    >
      <h3 style={{ color: "#FFFFFF" }}>
        💳 Mensalidades IKPAY
      </h3>

     <div>
  {mensalidades
    .filter((item) => item.clienteId === clienteFinanceiro?.id)
    .map((mensalidade) => (
      <div
        key={mensalidade.id}
        style={{
          padding: 12,
          marginBottom: 10,
          backgroundColor: "#172238",
          borderRadius: 8,
          color: "#FFFFFF",
        }}
      >
        <div>
          <strong>
            Referência:{" "}
            {formatarMesMensalidade(mensalidade.dataDeVencimento)}
          </strong>
        </div>

        <div style={{ fontSize: 22, fontWeight: 700, marginTop: 8 }}>
          {formatarValorMensalidade(mensalidade.valor)}
        </div>

        <Tag
          color={
            mensalidade.status === "PAGO"
              ? "#00C853"
              : mensalidade.status === "VENCIDO"
              ? "#FF4D4F"
              : "#AD6800"
          }
          style={{
            color: "#FFFFFF",
            fontWeight: 700,
            marginTop: 8,
          }}
        >
          {mensalidade.status}
        </Tag>

        <div style={{ marginTop: 8, color: "#CBD5E1" }}>
          Vencimento:{" "}
          {formatarDataMensalidade(mensalidade.dataDeVencimento)}
        </div>

        {["ABERTO", "VENCIDO"].includes(mensalidade.status) && (
          <Button
            type="primary"
            block
            loading={confirmandoPagamentoId === mensalidade.id}
            disabled={!!confirmandoPagamentoId}
            onClick={() => confirmarPagamentoMensalidade(mensalidade)}
            style={{
              marginTop: 12,
              backgroundColor: "#52c41a",
              borderColor: "#52c41a",
            }}
          >
            Confirmar pagamento
          </Button>
        )}
      </div>
    ))}
</div>
    </div>

    <div
      style={{
        marginTop: 20,
        padding: 20,
        backgroundColor: "#243450",
        borderRadius: 10,
      }}
    >
      <h3 style={{ color: "#FFFFFF" }}>
        💰 Cobranças Extras
      </h3>

      <div>
  {carregandoExtras && (
    <p style={{ color: "#CBD5E1" }}>Carregando cobranças...</p>
  )}

  {erroExtras && (
    <p style={{ color: "#FF7875" }}>{erroExtras}</p>
  )}

  {!carregandoExtras && !erroExtras && (() => {
    const extrasCliente = cobrancasExtras.filter(
      (extra) => extra.clienteId === clienteFinanceiro?.id
    );

    if (extrasCliente.length === 0) {
      return (
        <p style={{ color: "#CBD5E1" }}>
          Nenhuma cobrança extra cadastrada.
        </p>
      );
    }

    return extrasCliente.map((extra) => {
      const parcelas = extra.parcelas || [];

      const pagas = parcelas.filter(
        (parcela) => !!parcela.dataPagamento
      );

      const saldoCentavos = parcelas
        .filter((parcela) => !parcela.dataPagamento)
        .reduce(
          (total, parcela) => total + parcela.valorCentavos,
          0
        );

      const detalhesAbertos = !!detalhesExtrasAbertos[extra.id];

      return (
        <div
          key={extra.id}
          style={{
            padding: 12,
            marginBottom: 12,
            borderRadius: 8,
            backgroundColor: "#172238",
            color: "#FFFFFF",
          }}
        >
          <strong>{extra.descricao}</strong>

          <div style={{ marginTop: 8 }}>
            Valor total:{" "}
            {formatarValorMensalidade(
              extra.valorTotalCentavos / 100
            )}
          </div>

          <div>
            Parcelas pagas: {pagas.length} de {parcelas.length}
          </div>

          <div>
            {extra.cancelada ? "Saldo cancelado" : "Saldo pendente"}:{" "}
            {formatarValorMensalidade(
              extra.cancelada ? 0 : saldoCentavos / 100
            )}
          </div>

          <Tag
            color={
              extra.cancelada
                ? "#FF4D4F"
                : saldoCentavos === 0
                ? "#00C853"
                : "#AD6800"
            }
            style={{
              color: "#FFFFFF",
              fontWeight: 700,
              border: "none",
              padding: "3px 10px",
              borderRadius: 6,
              marginTop: 8,
            }}
          >
            {extra.cancelada
              ? "CANCELADA"
              : saldoCentavos === 0
              ? "QUITADA"
              : "EM ANDAMENTO"}
          </Tag>

          <Button
            type="link"
            style={{
              paddingLeft: 0,
              display: "block",
              marginTop: 8,
            }}
            onClick={() =>
              setDetalhesExtrasAbertos((anterior) => ({
                ...anterior,
                [extra.id]: !anterior[extra.id],
              }))
            }
          >
            {detalhesAbertos ? "Ocultar detalhes" : "Ver detalhes"}
          </Button>

          {!extra.cancelada && saldoCentavos > 0 && (
            <>
              <Button
                type="primary"
                block
                loading={operacaoExtraId === extra.id}
                disabled={
                  !!operacaoExtraId ||
                  !(parcelasExtrasSelecionadas[extra.id] || []).length
                }
                onClick={() => confirmarPagamentoParcelasExtras(extra)}
                style={{
                  marginTop: 10,
                  backgroundColor: "#52C41A",
                  borderColor: "#52C41A",
                }}
              >
                Confirmar parcelas selecionadas
              </Button>

              <Button
                danger
                block
                loading={operacaoExtraId === extra.id}
                disabled={!!operacaoExtraId}
                onClick={() => cancelarCobrancaExtra(extra)}
                style={{ marginTop: 8 }}
              >
                Cancelar cobrança extra
              </Button>
            </>
          )}

          {detalhesAbertos && (
            <div
              style={{
                borderTop: "1px solid rgba(255,255,255,0.15)",
                paddingTop: 10,
                marginTop: 10,
                fontSize: 12,
              }}
            >
              {extra.observacao && (
                <p>Observação: {extra.observacao}</p>
              )}

              {parcelas.map((parcela) => {
                const jaPaga = !!parcela.dataPagamento;
                const cancelada = !!extra.cancelada;

                const selecionadas =
                  parcelasExtrasSelecionadas[extra.id] || [];

                const selecionada = selecionadas.includes(parcela.id);

                return (
                  <div
                    key={parcela.id}
                    style={{
                      marginBottom: 10,
                      padding: 8,
                      borderRadius: 6,
                      backgroundColor: "#243450",
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      flexWrap: "wrap",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selecionada && !jaPaga && !cancelada}
                      disabled={
                        jaPaga || cancelada || !!operacaoExtraId
                      }
                      onChange={(e) => {
                        const marcada = e.target.checked;

                        setParcelasExtrasSelecionadas((anterior) => {
                          const atuais = anterior[extra.id] || [];

                          return {
                            ...anterior,
                            [extra.id]: marcada
                              ? [...atuais, parcela.id]
                              : atuais.filter(
                                  (id) => id !== parcela.id
                                ),
                          };
                        });
                      }}
                    />

                    <span>
                      Parcela {parcela.numeroParcela} —{" "}
                      {parcela.competencia} —{" "}
                      {formatarValorMensalidade(
                        parcela.valorCentavos / 100
                      )}
                    </span>

                    <Tag
                      color={
                        jaPaga
                          ? "#00C853"
                          : cancelada
                          ? "#FF4D4F"
                          : "#AD6800"
                      }
                      style={{
                        color: "#FFFFFF",
                        fontWeight: 700,
                        border: "none",
                      }}
                    >
                      {jaPaga
                        ? "PAGA"
                        : cancelada
                        ? "CANCELADA"
                        : "PENDENTE"}
                    </Tag>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      );
    });
  })()}
</div>
    </div>
  </div>
</Modal>

{/* =========================================
    IKPAY - ATUALIZAR CADASTRO DO CLIENTE
========================================= */}
<Modal
  title={`✏️ Atualizar Cadastro - ${clienteCadastro?.nome || ""}`}
  visible={modalCadastroAberto}
  onCancel={() => {
    if (salvandoCadastro) return;

    setModalCadastroAberto(false);
    setClienteCadastro(null);
    formCadastro.resetFields();
  }}
  footer={null}
  centered
  width={500}
  zIndex={99999}
  destroyOnClose
  bodyStyle={{
    backgroundColor: "#172238",
    color: "#FFFFFF",
    padding: "24px",
  }}
>
  <Form
    form={formCadastro}
    layout="vertical"
    onFinish={salvarAtualizacaoCadastro}
  >
    <Form.Item
      name="cpf"
      label="CPF"
      rules={[
        {
          validator: (_, value) => {
            const cpf = String(value || "").replace(/\D/g, "");

            if (!cpf || cpf.length === 11) {
              return Promise.resolve();
            }

            return Promise.reject(
              new Error("Informe um CPF com 11 dígitos.")
            );
          },
        },
      ]}
    >
      <Input
        placeholder="000.000.000-00"
        maxLength={14}
        onChange={(e) => {
          const numeros = e.target.value
            .replace(/\D/g, "")
            .slice(0, 11);

          const formatado = numeros
            .replace(/^(\d{3})(\d)/, "$1.$2")
            .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
            .replace(/\.(\d{3})(\d)/, ".$1-$2");

          formCadastro.setFieldsValue({
            cpf: formatado,
          });
        }}
      />
    </Form.Item>

    <Form.Item
      name="telefone"
      label="Telefone / WhatsApp"
      rules={[
        {
          validator: (_, value) => {
            const telefone = String(value || "").replace(/\D/g, "");

            if (!telefone || [10, 11].includes(telefone.length)) {
              return Promise.resolve();
            }

            return Promise.reject(
              new Error("Informe um telefone válido.")
            );
          },
        },
      ]}
    >
      <Input
        placeholder="(00) 00000-0000"
        maxLength={15}
        onChange={(e) => {
          const numeros = e.target.value
            .replace(/\D/g, "")
            .slice(0, 11);

          const formatado = numeros
            .replace(/^(\d{2})(\d)/, "($1) $2")
            .replace(/(\d{5})(\d{4})$/, "$1-$2");

          formCadastro.setFieldsValue({
            telefone: formatado,
          });
        }}
      />
    </Form.Item>

    <Button
      type="primary"
      htmlType="submit"
      loading={salvandoCadastro}
      block
      style={{
        backgroundColor: "#1890ff",
        borderColor: "#1890ff",
      }}
    >
      💾 Salvar Alterações
    </Button>
  </Form>
</Modal>

      {/* Clientes Pendentes Modal */}
      {listClientesPendentes && (
        <Card 
          title="Clientes em Análise" 
          style={{ marginTop: '24px', background: 'rgba(255, 255, 255, 0.02)', border: '1px solid rgba(255, 255, 255, 0.08)' }}
          extra={
            <Button type="default" onClick={() => dataData()}>
              Voltar para Ativos
            </Button>
          }
        >
          <Row gutter={[16, 16]}>
            {totalClientes.map((post) => (
              <Col xs={24} sm={12} lg={8} key={post.id}>
                <Card 
                  style={{ 
                    background: 'rgba(255, 255, 255, 0.06)',
                    border: '1px solid rgba(255, 255, 255, 0.12)',
                    borderLeft: '4px solid #faad14'
                  }}
                >
                  <div style={{ marginBottom: '12px' }}>

  <h3
    style={{
      margin: '0 0 8px 0',
      color: 'rgba(233, 242, 255, 0.92)'
    }}
  >
    {post.nome}
  </h3>

  <p style={{ margin: '0 0 4px 0', color: 'rgba(233, 242, 255, 0.72)' }}>
    <strong>CPF:</strong>{' '}
    {post.cpf
      ? String(post.cpf)
          .replace(/\D/g, '')
          .replace(
            /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
            '$1.$2.$3-$4'
          )
      : 'Não informado'}
  </p>

  <p style={{ margin: '0 0 4px 0', color: 'rgba(233, 242, 255, 0.72)' }}>
    <strong>Telefone:</strong>{' '}
    {post.telefone
      ? String(post.telefone)
          .replace(/\D/g, '')
          .replace(
            /^(\d{2})(\d{5})(\d{4})$/,
            '($1) $2-$3'
          )
          .replace(
            /^(\d{2})(\d{4})(\d{4})$/,
            '($1) $2-$3'
          )
      : 'Não informado'}
  </p>

  <p style={{ margin: '0 0 8px 0', color: 'rgba(233, 242, 255, 0.72)' }}>
    <strong>E-mail:</strong> {post.email}
  </p>

  <Tag color="#faad14">Pendente</Tag>

</div>
                  <div style={{ fontSize: '14px', color: 'rgba(233, 242, 255, 0.72)', marginBottom: '12px' }}>
                    <div><b>Endereço:</b></div>
                    <div>{`${post.endereco}, ${post.bairro}, N${post.numero}`}</div>
                    <div>{`CEP: ${post.cep} - ${post.cidade}/${post.uf}`}</div>
                    {post.complemento && <div>{post.complemento}</div>}
                    {post.referencia && <div>{post.referencia}</div>}
                  </div>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <Button 
                      type="primary" 
                      size="small" 
                      onClick={() => ativaCliente(post)}
                      icon={<AiOutlineCheck />}
                    >
                      Ativar
                    </Button>
                    <Button 
                      danger 
                      size="small" 
                      onClick={() => dataDataPendentes()}
                      icon={<AiOutlineClose />}
                    >
                      Rejeitar
                    </Button>

                        <Button
  type="primary"
  size="small"
  style={{
    backgroundColor: "#1890ff",
    borderColor: "#1890ff",
  }}
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();

    setClienteCadastro(post);

    formCadastro.setFieldsValue({
      cpf: post.cpf || "",
      telefone: post.telefone || "",
    });

    setModalCadastroAberto(true);
  }}
>
  ✏️ Atualizar Cadastro
</Button>
    
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Card>
           )}
    </div>
  );
};

export default ClientesDashboard;
